import axios, { AxiosResponse } from 'axios';
import Config from '@/config';
import users from '@/store/modules/users';

export default class UserService {
  public async login(email: string, password: string): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.post(Config.baseApiUrl + '/auth/login', {
        email,
        password,
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getCurrentUser(token: string): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/user/currentUser', {
        headers: {
          auth: `${token}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async createUser(
    email: string,
    password: string,
    role: string,
  ): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.post(
        Config.baseApiUrl + '/user',
        {
          email,
          password,
          role,
        },
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }
}
